module.exports = __webpack_public_path__ + "static/media/horse-intersection.bab98b9e.svg";